







import Vue from "vue";
import GameScreen from "./components/GameScreen.vue";
import JoinScreen from "./components/JoinScreen.vue";

export default Vue.extend({
  name: "App",
  components: {
    GameScreen,
    JoinScreen
  },
  methods: {}
});
